let prevScrollpos = window.pageYOffset;
window.onscroll = function () {
    let currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos || currentScrollPos <= 65) {
        document.querySelector('.header').classList.remove('header--hidden');
    } else {
        document.querySelector('.header').classList.add('header--hidden');
    }
    prevScrollpos = currentScrollPos;
};

// Hide and show 'Call-To-Actions'-menu on the bottom for mobile devices
const mobileBottomBtn = document.querySelector('.mobile-bottom-menu');
var showScroll = function () {
    var y = window.scrollY;

    if (prevScrollpos < y || y > 65) {
        mobileBottomBtn.classList.add('show');
        mobileBottomBtn.style.visibility = 'visible';
    } else {
        mobileBottomBtn.classList.remove('show');
        mobileBottomBtn.style.visibility = 'hidden';
    }
};

window.addEventListener('scroll', showScroll);
